import withResponsive from '../hoc/withResponsive'
import onResize from '../utils/onResize'
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper/core'
import 'swiper/css'

SwiperCore.use([Pagination, Navigation, Autoplay])

export default withResponsive({
  name: 'slider',

  ui: {
    pagination: '[js-slider-pagination]',
    navigation: '[js-slider-navigation]',
    slider: '[js-slider-el]',
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.options = {
      threshold: 30,
    }

    if (this.ui.pagination) {
      this.props.options.pagination = {
        el: this.ui.pagination,
        type: 'bullets',
      }
    }

    if (this.ui.navigation) {
      this.props.options.navigation = {
        nextEl: this.ui.navigation.querySelector('.swiper-button-next'),
        prevEl: this.ui.navigation.querySelector('.swiper-button-prev'),
      }
    }

    this.options = { ...this.options, ...this.props.options }

    this.slider = new SwiperCore(this.ui.slider, this.options)

    if (this.slider && this.slider.slides !== undefined) {
      this.checkDisable()
    }
  },

  componentWillUnmount () {
    this.off()

    this.slider.destroy()
    if (this.ui.pagination) this.ui.pagination.innerHTML = ''
  },

  onResize () {
    if (this.slider && this.slider.slides !== undefined) {
      setTimeout(() => {
        this.checkDisable()
      }, 500)
    }
  },

  checkDisable () {
    if (this.slider.slides !== 'undefined') {
      const nbSlides = this.slider.slides.length

      if (window.innerWidth < 768 && nbSlides < 2) {
        if (typeof this.options.allowTouchMove === 'undefined' || this.options.allowTouchMove) this.slider.allowTouchMove = false
        if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
      } else {
        if (typeof this.options.allowTouchMove === 'undefined' || this.options.allowTouchMove) this.slider.allowTouchMove = true
        if (this.ui.pagination) this.ui.pagination.classList.remove('is-hidden')
      }

      if (this.props.options.breakpoints) {
        Object.entries(this.props.options.breakpoints).forEach((breakpoint) => {
          if (
            window.innerWidth >= breakpoint[0] &&
            nbSlides / breakpoint[1].slidesPerView <= 1
          ) {
            this.slider.allowTouchMove = false
            if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
            if (this.ui.navigation) this.ui.navigation.classList.add('is-hidden')
          } else {
            this.slider.allowTouchMove = true
            if (this.ui.pagination) {
              this.ui.pagination.classList.remove('is-hidden')
            }
            if (this.ui.navigation) this.ui.navigation.classList.remove('is-hidden')
          }
        })
      }
    }
  },
})
